'use client';

import { Flex } from '@chakra-ui/react';
import dynamic from 'next/dynamic';

import spinner from '../../../public/Animation - spinner.json';

const Lottie = dynamic(() => import('react-lottie-player'), { ssr: false });

export const AppSpinner = () => {
    return (
        <Flex textAlign={'center'} h={'90vh'}>
            <Lottie animationData={spinner} play={true} loop={true} style={{ width: '10%', height: '10%', margin: 'auto' }} />
        </Flex>
    );
};
